module.exports = __webpack_public_path__ + "img/1.5fc45a0f.png";